import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const CircleHalfFilled = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M2 12C2 6.47715 6.47715 2 12 2C12.6666 2 13.3189 2.06536 13.9505 2.19032L13.5624 4.15229C13.0579 4.05249 12.5356 4 12 4V20C12.5356 20 13.0579 19.9475 13.5624 19.8477L13.9505 21.8097C13.3189 21.9346 12.6666 22 12 22C6.47715 22 2 17.5228 2 12Z"
      fill="currentColor"
    />
    <path
      d="M16.4442 5.34688C17.3171 5.93123 18.0688 6.68294 18.6531 7.55578L20.3151 6.44314C19.5853 5.35306 18.6469 4.41474 17.5569 3.68494L16.4442 5.34688Z"
      fill="currentColor"
    />
    <path
      d="M19.8477 10.4376C19.9475 10.9421 20 11.4644 20 12C20 12.5356 19.9475 13.0579 19.8477 13.5624L21.8097 13.9505C21.9346 13.3189 22 12.6666 22 12C22 11.3334 21.9346 10.6811 21.8097 10.0495L19.8477 10.4376Z"
      fill="currentColor"
    />
    <path
      d="M18.6531 16.4442C18.0688 17.3171 17.3171 18.0688 16.4442 18.6531L17.5569 20.3151C18.6469 19.5853 19.5853 18.6469 20.3151 17.5569L18.6531 16.4442Z"
      fill="currentColor"
    />
  </Icon>
));

export default CircleHalfFilled;
